import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/TonConnectProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
